<template>
    <div>
        <hr>
        <h2>Оставьте заявку на участие в розыгрыше призов до 26 декабря 2020 г.</h2>

        <div v-if="loading" class="text-center">
            <RippleLoader :color="'#5ab947'" :duration="'1.5s'"/>
        </div>

        <div
                class="ui-comment-notify"
                v-else-if="isCreated"
        >
            <i class="ui-comment-notify__icon fa fa-check-circle"></i>
            <div class="ui-comment-notify__description">
                <strong>Благодарим за заявку!</strong><br>
                Ваша заявка принята, отправлять повторно ее не нужно.
            </div>
        </div>


        <div v-else
             class="row ui-comment-form justify-content-around mt-4">
            <div class="col-12">
                <base-alert dismissible type="danger" v-if="error">{{error}}</base-alert>
            </div>
            <div class="col-12 col-lg-6">
                <base-input alternative=""
                            placeholder="Фамилия, имя ребенка"
                            input-classes="form-control-alternative"
                            v-model="name"
                />
            </div>
            <div class="col-12 col-lg-6">
                <base-input alternative=""
                            placeholder="Возраст ребенка"
                            input-classes="form-control-alternative"
                            v-model="age"
                />
            </div>
            <div class="col-12">
                <base-input alternative=""
                            placeholder="Ссылка на профиль в соцсети"
                            input-classes="form-control-alternative"
                            v-model="link"
                />
            </div>
            <div class="col-12 mb-6">
                <button @click="createComment" class="btn btn-info ui-btn ui-btn--info d-block d-sm-inline-block">
                    Отправить заявку
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import courseApi from '@/data/CourseApi';
    import CStorage from "../../data/CStorage";
    import {RippleLoader} from 'vue-spinners-css';

    export default {
        name: 'CourseCommentsAdvent',

        props: {
            course: {
                type: Object,
                required: true,
            }
        },

        components: {
            RippleLoader,
        },

        data() {
            return {
                isCreated: false,

                name: null,
                age: null,
                link: null,

                error: null,
                loading: false,
            }
        },

        mounted() {
            this.isCreated = CStorage.getItem('ADVENT_isCreated', this.isCreated)
        },

        methods: {
            createComment() {
                this.error = null
                if (!this.name || !this.age || !this.link) {
                    this.error = "Пожалуйста, заполните все поля формы заявки";
                    return;
                }
                this.loading = true
                courseApi.createComment(this.course.idcourse,
                    "Заявка на участие в адвенте:\n"
                    + "Имя ребенка: " + this.name + "\n"
                    + "Возраст: " + this.age + "\n"
                    + "Ссылка: " + this.link)
                    .then(() => {
                        this.isCreated = true
                        CStorage.setItem('ADVENT_isCreated', this.isCreated)
                        this.name = null
                        this.age = null
                        this.link = null
                        this.loading = false
                    })
            },

        },

    }
</script>

<style>
    .ui-comments {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .ui-comments__item {
        margin-bottom: 40px;
    }

    .ui-comment-form {
        max-width: 100%;
        margin: 0;
        text-align: center;
    }

    .ui-comment-form__input {
        padding: 5px 10px;
    }

    .ui-comment-notify {
        background-color: rgba(0, 0, 0, .05);
        border-radius: 20px;
        margin: 0 auto 100px;
        max-width: 600px;
        padding: 20px;
        text-align: center;
    }

    .ui-comment-notify__icon {
        color: #58B946;
        font-size: 4rem;
        margin-bottom: 20px;
    }
</style>
